import moment from 'moment';
import 'moment-timezone';
import React from 'react';
import {Link} from 'react-router';

import GlobalActions from '../actions/GlobalActions';

import withRouter from '../utils/with-router';

@withRouter
class ShiftHeader extends React.Component {

    constructor(props) {
        super(props);
    }

    backToAgenda() {
        const shift_start = moment(this.props.shift.start_date).tz(this.props.shift.company.timezone);
        GlobalActions.saveDashboardDate(shift_start.startOf('day'));
        this.context.router.transitionTo('agenda');
    }

    render () {
        const shift = this.props.shift;
        const position = this.props.shift.position || {};
        const hireUpdate = this.props.hireUpdate;

        return (
            <header className="shift-header">
                <div className="maxwidth-wrapper">
                    <div className="left">
                        <button onClick={this.backToAgenda.bind(this)} className="arrow-container"><div className="arrow"></div></button>
                        <h1 className="page-title">{shift.workers_needed} {position.name} {shift.workers_needed && position.name ? '-' : ''} {shift.venue} {moment(shift.start_time).tz(shift.company.timezone).format('DD.MM.YYYY')}</h1>
                    </div>
                    <div className="right">
                        <button onClick={this.props.duplicateShift} className="btn-transparent btn-cancel">DUPLICATE</button>
                        {shift.status == 'finished' || shift.status == 'cancelled' || moment(shift.end_time) < moment() ? '' : <Link to="editshift" params={{shiftId: this.props.shiftId}} className="btn btn-small btn-green btn-save-shift">Edit</Link>}
                        {hireUpdate ? '' : <button className="btn btn-small btn-green btn-save-shift" onClick={this.props.togglePostUpdateModal}>Send an update</button>}
                    </div>
                </div>
            </header>
        );
    }
}

export default ShiftHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/ShiftHeader.js
 **/